import { Builder } from '@builder.io/react';
import { BUILDER_DIVIDER_NAMES } from '../BuilderComponentsName';
import LHRBenefitsBuilder from '../../components/lp/LHRBenefits';

Builder.registerComponent(LHRBenefitsBuilder, {
    name: BUILDER_DIVIDER_NAMES.LHRBenefits,
});
